import {
  DisbursementStatus,
  ReportsRow,
} from '../../../modules/revenueInsightsV2/types'
import { Grid, Typography } from '@mui/material'
import { useStyles } from './RevenueInsightsCommon.style'
import { StatusChipV4 } from '@labrav/react-components'
import { useCurrentCloudProvider } from '@labrav/common'
import { getStatusAndLabelForRevenueInsights } from '../../../common/utils/getStatusAndLabelForRevenueInsights'
import { formatToDecimalPlaces } from '../../../common/utils/revenueHelpers'

export interface RevenueInsightsProductComponentProps {
  reportRow: ReportsRow
  currencySymbol?: string
}
export const RevenueInsightsProductComponent: React.FC<
  RevenueInsightsProductComponentProps
> = ({ reportRow, currencySymbol }) => {
  const { classes } = useStyles()
  const selectedCloudTypeProductListing = useCurrentCloudProvider()
  const statusLabel = getStatusAndLabelForRevenueInsights(
    reportRow?.disbursementStatus as DisbursementStatus
  )

  const isGcp = selectedCloudTypeProductListing === 'GCP'

  return (
    <>
      <div>
        <Grid
          container
          className={classes.productContainer}
          data-testid="product_container"
        >
          <Grid className={classes.gridContainer} size={isGcp ? 6 : 12}>
            <Typography className={classes.rowTitle}>Product title</Typography>
            <Typography className={classes.rowValue}>
              {reportRow.productTitle || '-'}
            </Typography>
          </Grid>

          <Grid className={classes.gridContainer} size={isGcp ? 6 : 12}>
            <Typography className={classes.rowTitle}>Net revenue</Typography>
            <Typography className={classes.rowValue}>
              {currencySymbol}
              {formatToDecimalPlaces(
                reportRow.sellerNetRevenue || reportRow.netRevenue
              )}
            </Typography>
          </Grid>

          <Grid className={classes.gridContainer} size={isGcp ? 6 : 4}>
            <Typography className={classes.rowTitle}>Invoice date</Typography>
            <Typography className={classes.rowValue}>
              {reportRow.invoiceDate || '-'}
            </Typography>
          </Grid>

          {!isGcp && (
            <Grid className={classes.gridContainer} size={4}>
              <Typography className={classes.rowTitle}>Invoice ID</Typography>
              <Typography className={classes.rowValue}>
                {reportRow.invoiceId || '-'}
              </Typography>
            </Grid>
          )}

          {selectedCloudTypeProductListing === 'AWS' ? (
            <Grid className={classes.gridContainer} size={4}>
              <Typography className={classes.rowTitle}>
                Payment terms
              </Typography>
              <Typography className={classes.rowValue}>
                Net {reportRow.paymentTerms || '-'}
              </Typography>
            </Grid>
          ) : (
            <></>
          )}

          {!isGcp && (
            <Grid className={classes.gridContainer} size={4}>
              <Typography className={classes.rowTitle}>
                Payment due date
              </Typography>
              <Typography className={classes.rowValue}>
                {reportRow.paymentDueDate || '-'}
              </Typography>
            </Grid>
          )}

          <Grid className={classes.gridContainer} size={isGcp ? 6 : 4}>
            <Typography className={classes.rowTitle}>
              Disbursement status
            </Typography>
            <Typography className={classes.rowValue}>
              <StatusChipV4 {...statusLabel} />
            </Typography>
          </Grid>

          {!isGcp && (
            <Grid className={classes.gridContainer} size={4}>
              <Typography className={classes.rowTitle}>
                Disbursement date
              </Typography>
              <Typography className={classes.rowValue}>
                {reportRow.disbursementDate || '-'}
              </Typography>
            </Grid>
          )}
        </Grid>
      </div>
    </>
  )
}
